import { IGroupByListColumn } from "models/groupBy";

export const PRODUCTION_SUMMARY_GROUP = "Production Summary";
export const PRODUCTION_SUMMARY_PROPERTY_PREFIX = "Production_Summary.";
const PRODUCTION_SUMMARY_RATIO_SUBGROUPS = ["GOR", "WOR"];

// Mirrors data-svc's is_normalizable_production_summary.
export const isNormalizedProductionSummary = (
  column: Pick<IGroupByListColumn, "group" | "dataType" | "subgroup">
): boolean =>
  column.group === PRODUCTION_SUMMARY_GROUP &&
  column.dataType === "Number" &&
  !PRODUCTION_SUMMARY_RATIO_SUBGROUPS.includes(column.subgroup);

// For callers holding only a property; their date values are strings and never divided.
export const isNormalizedProductionSummaryProperty = (property: string): boolean =>
  property.startsWith(PRODUCTION_SUMMARY_PROPERTY_PREFIX) &&
  !PRODUCTION_SUMMARY_RATIO_SUBGROUPS.some((ratio) => property.endsWith(ratio));
